import { FC, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CourseEvent } from '../../../models/CourseEvent';
import MailEndpoint from '../../../../api/endpoint/MailEndpoint';
import Spinner from 'react-bootstrap/esm/Spinner';
import { displayFullDateAsVtTime } from '../../../utils/DateManagement';

interface ConfirmSendCertificates {
    courseEvent: CourseEvent;
    show: boolean;
    onHide: () => void;
}



export const ConfirmSendCertificates: FC<ConfirmSendCertificates> = ({courseEvent, show, onHide}) => {
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    const onSend = async() => {
        try{
            setIsLoading(true);
            const sendResult = await MailEndpoint.SendCertificates(courseEvent.course_event_id);
            setIsLoading(false);

            if(sendResult.errors && sendResult.errors.length > 0) {
                setMessage('Error: ' + sendResult.errors.join(', '));
                return;
            }

            if(sendResult.data.rejected && sendResult.data.rejected.length > 0) {
                setMessage('Failure sending to the following emails: ' + sendResult.data.rejected.join(', '));
                return;
            }
            
            setMessage('');
            onHide();
        } catch(err) {
            setIsLoading(false);
            setMessage('Error: ' + (err instanceof Error ? err.message : String(err)));
        }
    };

    return(
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="send-certificates-title"
            centered
        >
            <Modal.Header>
                <Modal.Title id="send-certificates-title">Send Certificates?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Send certificates for {courseEvent.title} ending on {displayFullDateAsVtTime(courseEvent.end_date)}?
                <div className="text-danger">
                    {courseEvent.end_date > new Date() &&
                        <div>The final class for this course has not taken place yet.</div>
                    }
                    {!isLoading &&
                        <>{message}</>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                {isLoading &&
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                }
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" className="text-light" onClick={onSend}>Send</Button>
            </Modal.Footer>
        </Modal>
    )
};